module.exports = __webpack_public_path__ + "static/img/envelope02vi.d2ed45e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hongbao/img/envelope02vi.png
// module id = MpkK
// module chunks = 1